const providersPriority: { [key: string]: { prio1: number[]; prio2: number[] } } = {
	ar: {
		prio1: [384, 337, 2] /* hbm dnp, itu */,
		prio2: [619] /* srp */,
	},
	at: {
		prio1: [337, 2] /* dnp, itu */,
		prio2: [],
	},
	au: {
		prio1: [385, 119, 337, 2, 151, 269, 223, 134] /* bng, prv, dnp, itu, bbo, fmn, hay, ftp */,
		prio2: [],
	},
	bb: {
		prio1: [384] /* hbm */,
		prio2: [],
	},
	be: {
		prio1: [337, 2] /* dnp, itu */,
		prio2: [223] /* hay */,
	},
	bo: {
		prio1: [384, 337, 2] /* hbm, dnp, itu */,
		prio2: [619] /* srp */,
	},
	br: {
		prio1: [384, 337, 619, 119, 2, 269] /* hbm, dnp, srp, prv, itu, fmn */,
		prio2: [],
	},
	bs: {
		prio1: [384] /* hbm */,
		prio2: [],
	},
	ca: {
		prio1: [337, 2, 223] /* dnp, itu, hay */,
		prio2: [],
	},
	ch: {
		prio1: [337] /* dnp */,
		prio2: [2] /* itu */,
	},
	cl: {
		prio1: [384, 337, 2] /* hbm, dnp, itu */,
		prio2: [619] /* srp */,
	},
	co: {
		prio1: [384, 337, 2] /* hbm, dnp, itu */,
		prio2: [619] /* srp */,
	},
	cr: {
		prio1: [384, 337, 2] /* hbm, dnp, itu */,
		prio2: [619] /* srp */,
	},
	de: {
		prio1: [29, 30, 337, 9, 2, 223, 194, 195, 204] /* skg, sko, dnp, amp, itu, hay, ast, aan, asd */,
		prio2: [],
	},
	dk: {
		prio1: [337, 2] /* dnp, itu */,
		prio2: [384, 223] /* hbm, hay */,
	},
	do: {
		prio1: [384] /* hbm */,
		prio2: [],
	},
	ec: {
		prio1: [384, 337, 2] /* hbm, dnp, itu */,
		prio2: [619] /* srp */,
	},
	es: {
		prio1: [337, 2, 257, 223, 63] /* dnp, itu, fuv, hay, fil */,
		prio2: [],
	},
	fi: {
		prio1: [337, 2] /* dnp, itu */,
		prio2: [384, 223] /* hbm, hay */,
	},
	fr: {
		prio1: [337, 119, 2] /* dnp, prv, itu */,
		prio2: [345, 381, 223] /* canal+ series, canal+, hay */,
	},
	gt: {
		prio1: [384, 337, 2] /* hbm, dnp, itu */,
		prio2: [619] /* srp */,
	},
	hn: {
		prio1: [384, 337, 2] /* hbm, dnp, itu */,
		prio2: [619] /* srp */,
	},
	hu: {
		prio1: [384] /* hbm */,
		prio2: [],
	},
	ie: {
		prio1: [337, 2] /* dnp, itu */,
		prio2: [223] /* hay */,
	},
	in: {
		prio1: [223] /* hayu */,
		prio2: [],
	},
	it: {
		prio1: [337, 2, 223, 119] /* dnp, itu, hay, prv */,
		prio2: [],
	},
	jm: {
		prio1: [384] /* hbm */,
		prio2: [],
	},
	jp: {
		prio1: [337, 2] /* dnp, itu */,
		prio2: [],
	},
	mx: {
		prio1: [337, 619, 119, 384, 2, 269] /* dnp, srp, prv, hbm, itu, fmn */,
		prio2: [],
	},
	nl: {
		prio1: [384, 337, 2] /* hbm dnp, itu */,
		prio2: [223] /* hay */,
	},
	no: {
		prio1: [337, 2] /* dnp, itu */,
		prio2: [384, 223] /* hbm, hay */,
	},
	nz: {
		prio1: [337, 2] /* dnp, itu */,
		prio2: [269] /* fmn */,
	},
	pa: {
		prio1: [384] /* hbm */,
		prio2: [],
	},
	pe: {
		prio1: [384, 337, 2] /* hbm, dnp, itu */,
		prio2: [619] /* srp */,
	},
	ph: {
		prio1: [2] /* itu */,
		prio2: [],
	},
	pl: {
		prio1: [384, 2] /* hbm, itu */,
		prio2: [118] /* hbo */,
	},
	pt: {
		prio1: [384, 337, 2] /* hbm, dnp, itu */,
		prio2: [],
	},
	py: {
		prio1: [384, 337, 2] /* hbm, dnp, itu */,
		prio2: [],
	},
	se: {
		prio1: [337, 2] /* dnp, itu */,
		prio2: [384, 223] /* hbm, hay */,
	},
	sg: {
		prio1: [2] /* itu */,
		prio2: [337] /* dnp */,
	},
	sv: {
		prio1: [384] /* hbm */,
		prio2: [],
	},
	uk: {
		prio1: [337, 9, 2, 223, 194, 204, 201, 269] /* dnp, amp, itu, hay, ast, asd, amu, fmn */,
		prio2: [],
	},
	uy: {
		prio1: [384, 2] /* hbm, itu */,
		prio2: [619] /* srp */,
	},
	ve: {
		prio1: [384, 337, 2] /* hbm, dnp, itu */,
		prio2: [619] /* srp */,
	},
	us: {
		prio1: [
			337, 9, 2, 15, 384, 257, 531, 269, 331, 528, 194, 203, 582,
		] /* dnp, amp, itu, hlu, hbm, fuv, pmp, fmn, fxf, azp, ast, ash, app */,
		prio2: [583, 584, 343, 294, 293, 262, 196, 292] /* aep, adp, bpc, apm, apk, ang, aac, apa */,
	},
};

import { Offer } from '@/interfaces/titles';
import { WebLocale } from '@/enums/web-locale';
import { OfferHelper } from '@/helpers/offer-helper';
import { BuyboxOfferCategory } from '@/interfaces/buybox';

type PromotedOffers = { offers: number[]; categories: BuyboxOfferCategory[] };

export const PromotedBuyBoxHelper = {
	getPromotedOffers(webLocale: WebLocale, offers: Offer[]): PromotedOffers {
		const promotedOffers: PromotedOffers = { offers: [], categories: [] };
		const filteredOffers = getProvidersByCategory(offers, webLocale);

		for (const category of [BuyboxOfferCategory.STREAM, BuyboxOfferCategory.RENT, BuyboxOfferCategory.BUY]) {
			// If RENT offers available, don't add BUY offers
			if (promotedOffers.categories.includes(BuyboxOfferCategory.RENT)) {
				break;
			}
			if (filteredOffers[category].offers.length > 0 && filteredOffers[category].hasPrioProviders) {
				promotedOffers.categories.push(category);
			}
		}

		const prio1: number[] = [];
		const prio2: number[] = [];
		const localePrio1 = providersPriority[webLocale]?.prio1 || [];
		const localePrio2 = providersPriority[webLocale]?.prio2 || [];

		for (const offer in filteredOffers) {
			filteredOffers[offer].offers.forEach(offer => {
				if (localePrio1.includes(offer.provider_id) && !prio1.includes(offer.provider_id)) {
					prio1.push(offer.provider_id);
				}
				if (localePrio2.includes(offer.provider_id) && !prio2.includes(offer.provider_id)) {
					prio2.push(offer.provider_id);
				}
			});
		}

		// The following 2 sorts makes sure the priority order matches the priority object above
		prio1.sort((a, b) => {
			const id1index = providersPriority[webLocale].prio1.indexOf(a);
			const id2index = providersPriority[webLocale].prio1.indexOf(b);
			return id1index - id2index;
		});
		prio2.sort((a, b) => {
			const id1index = providersPriority[webLocale].prio2.indexOf(a);
			const id2index = providersPriority[webLocale].prio2.indexOf(b);
			return id1index - id2index;
		});

		if (prio1.length >= 1 && prio2.length >= 1) {
			promotedOffers.offers = [prio1[0], prio2[0]];
		} else if (prio1.length > 0) {
			promotedOffers.offers = prio1.slice(0, 2);
		} else if (prio2.length > 0) {
			promotedOffers.offers = prio2.slice(0, 2);
		}

		return promotedOffers;
	},
};

function getProvidersByCategory(offers: Offer[], webLocale: WebLocale) {
	const providers: { [key: string]: { offers: Offer[]; hasPrioProviders: boolean } } = {
		stream: { offers: [], hasPrioProviders: false },
		rent: { offers: [], hasPrioProviders: false },
		buy: { offers: [], hasPrioProviders: false },
	};

	offers.forEach(offer => {
		const category = OfferHelper.getBuyboxCategoryByMonetization(offer.monetization_type);
		switch (category) {
			case 'stream':
				providers.stream.offers.push(offer);
				providers.stream.hasPrioProviders = hasPrioProviders(providers.stream.offers, webLocale);
				break;
			case 'rent':
				providers.rent.offers.push(offer);
				providers.rent.hasPrioProviders = hasPrioProviders(providers.rent.offers, webLocale);
				break;
			case 'buy':
				providers.buy.offers.push(offer);
				providers.buy.hasPrioProviders = hasPrioProviders(providers.buy.offers, webLocale);
				break;
		}
	});
	return providers;
}

function hasPrioProviders(offers: Offer[], webLocale: WebLocale): boolean {
	if (providersPriority[webLocale] !== undefined) {
		return offers.some(
			offer =>
				providersPriority[webLocale].prio1.includes(offer.provider_id) ||
				providersPriority[webLocale].prio2.includes(offer.provider_id)
		);
	}
	return false;
}
